import api from "../../../services/api/axios";

const OPTION_TYPES = new Set(["select", "radio", "checkbox"]);

function buildDateRangeParams({ startDate, endDate }) {
  const params = {};

  if (startDate) params.start_date = startDate;
  if (endDate) params.end_date = endDate;

  return params;
}

export function normalizeSurveyTemplate(template) {
  const questions = Array.isArray(template?.schema?.questions)
    ? template.schema.questions
    : Array.isArray(template?.questions)
      ? template.questions
      : [];

  return {
    ...template,
    version: template.version ?? 1,
    questions,
    is_custom: Boolean(template.is_custom),
  };
}

export function serializeSurveyQuestion(question) {
  const serialized = {
    id: question.id,
    type: question.type,
    label: question.label.trim(),
    required: Boolean(question.required),
  };

  if (OPTION_TYPES.has(question.type)) {
    serialized.options = (question.options || [])
      .map((option) => String(option).trim())
      .filter(Boolean);
  }

  return serialized;
}

export async function fetchSurveyTemplates({ signal } = {}) {
  const response = await api.get("/survey-templates", { signal });
  const data = response?.data?.data ?? response?.data ?? [];
  return Array.isArray(data) ? data.map(normalizeSurveyTemplate) : [];
}

export async function fetchSurveyResponses({ signal, startDate, endDate }) {
  const response = await api.get("/survey-responses/expanded", {
    params: buildDateRangeParams({ startDate, endDate }),
    signal,
  });

  return response.data || [];
}

export async function fetchSurveyStats({
  signal,
  templateSlug,
  startDate,
  endDate,
}) {
  const response = await api.get("/survey-responses/stats", {
    params: {
      template_slug: templateSlug,
      ...buildDateRangeParams({ startDate, endDate }),
    },
    signal,
  });

  return response.data || [];
}

export function createSurveyAnalysis(payload) {
  return api.post("/gpt/survey-analysis", payload);
}
